import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ApplicationState } from 'store';
import { AcademyState } from 'store/modules/academy_store/types';
import {
  academyDay,
  academyMonthAbbr,
  academyWeekdayTimeLabel,
  academyCountdownLabel,
} from 'services/academy_date';
import Loader from 'components/atoms/loader';
import AcademyButton from 'components/atoms/academy_button';
import AcademySubscriptionModal from 'components/molecules/academy_subscription_modal';
import SubscribedIcon from 'assets/images/icon_starred_seet_blue.svg';
import { Container } from './styles';

interface AcademyEventDetailProps {
  id: number;
}

const AcademyEventDetail: React.FC<AcademyEventDetailProps> = ({ id }) => {
  const history = useHistory();
  const { agenda, mySubscriptions, request } = useSelector<ApplicationState, AcademyState>(
    (s) => s.session.academy,
  );

  const [modalOpen, setModalOpen] = useState(false);

  const live = agenda.find((item) => item.id === id);
  const subscribed = useMemo(
    () => mySubscriptions.some((sub) => sub.live_id === id),
    [mySubscriptions, id],
  );

  const backButton = (
    <button type="button" className="back-link" onClick={() => history.push('/academy/calendario')}>
      <i className="material-icons">chevron_left</i>
      Voltar para os eventos do Calendário
    </button>
  );

  if (!live && request.agenda.loading) {
    return (
      <Container>
        {backButton}
        <div className="loading-wrapper">
          <Loader />
        </div>
      </Container>
    );
  }

  if (!live) {
    return (
      <Container>
        {backButton}
        <div className="empty-state">
          <p>Evento não encontrado.</p>
        </div>
      </Container>
    );
  }

  const isLive = live.status === 'live';

  const action = isLive ? (
    <AcademyButton icon="live_tv" block onClick={() => history.push('/academy/ao-vivo')}>
      Assistir ao vivo
    </AcademyButton>
  ) : subscribed ? (
    <AcademyButton variant="outline" imgIcon={SubscribedIcon} block>
      Inscrito
    </AcademyButton>
  ) : (
    <AcademyButton icon="event" block onClick={() => setModalOpen(true)}>
      Inscrever-se
    </AcademyButton>
  );

  return (
    <Container>
      {backButton}
      <div className="detail-card">
        <div className="detail-thumb">
          {live.thumbnail_url && <img src={live.thumbnail_url} alt={live.title} />}
        </div>

        <div className="badges">
          <span className="badge-pill">{academyCountdownLabel(live.scheduled_at, isLive)}</span>
          {live.category && <span className="badge-pill">{live.category}</span>}
        </div>

        <div className="detail-body">
          <div className="detail-main">
            <div className="detail-title">{live.title}</div>
            {live.description && <div className="detail-description">{live.description}</div>}
          </div>

          <div className="detail-side">
            <div className="date-box">
              <span className="day">{academyDay(live.scheduled_at)}</span>
              <span className="month">{academyMonthAbbr(live.scheduled_at)}</span>
            </div>
            <div className="side-datetime">{academyWeekdayTimeLabel(live.scheduled_at)}</div>
            {action}
          </div>
        </div>
      </div>

      <AcademySubscriptionModal show={modalOpen} live={live} onClose={() => setModalOpen(false)} />
    </Container>
  );
};

export default AcademyEventDetail;
